/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrdinamentoScolastico } from './ordinamento-scolastico';


export interface ProfiloStudenteSimulazioneForm { 
    possesso_isee: boolean;
    valore_isee?: number;
    ordine_beneficiario: number;
    numero_beneficiari: number;
    residenza: ProfiloStudenteSimulazioneFormResidenzaEnum;
    ordinamento: OrdinamentoScolastico;
}
export enum ProfiloStudenteSimulazioneFormResidenzaEnum {
    RESIDENTE = 'RESIDENTE',
    NON_RESIDENTE = 'NON_RESIDENTE'
};



